<template>
  <div>
    <q-dialog
      :visible="isVisible"
      :title="title"
      width="400px"
      :innerScroll="false"
      :loading="loading"
      @close="onCancel"
      @cancel="onCancel"
      @confirm="onConfirm"
    >
      <div class="content">
        <el-form
          ref="addForm"
          :model="addForm"
          :rules="rules"
          size="small"
          style="margin-top:20px"
          label-width="90px"
        >
          <el-form-item label="调整到:" prop="storeCode">
            <el-select v-model="addForm.storeCode" placeholder="请选择">
              <el-option
                v-for="item in storeOptions"
                :key="item.storeCode"
                :label="item.storeName"
                :value="item.storeCode"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="调整量:" prop="adjustNum">
            <el-input v-model="addForm.adjustNum" size="small" @input="addForm.adjustNum=addForm.adjustNum.replace(/^(0+)|[^\d]+/g,'')"></el-input>
          </el-form-item>
        </el-form>
      </div>
    </q-dialog>
  </div>
</template>

<script>
import {assignValue} from '@/utils/'
export default {
  name: "addDialog",
  components: {},
  props: {
    // 重新对外暴露visible，控制显示隐藏
    visible: {
      type: Boolean,
      default: false,
    },
    modifyData: Object,
    storeList: Array
  },
  computed: {
    // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
    title() {
      return "调整";
    },
    storeOptions() {
      return this.storeList.filter(v=> v.storeCode != this.modifyData.storeCode)
    }
  },
  data() {
    return {
      addForm: {
        // storeCode: '',
        dataId: '',
        adjustNum: ''
      },
      rules: {
        storeCode: [{ required: true, message: "请选择调整店铺", trigger: "change" }],
        adjustNum: [{ required: true, message: "请输入调整量", trigger: "blur" }],
      },
      loading: false
    };
  },
  methods: {
    init() {
      if (this.modifyData) {
        this.initModifyData()
      }
    },
    initModifyData() {
      assignValue(this.addForm, this.modifyData);
      console.log(this.modifyData);
    },
    onCancel() {
      this.isVisible = false;
    },
    onConfirm() {
      this.$refs.addForm.validate((valid) => {
        if (!valid) return;
        this.loading = true
        let params = {
          ...this.addForm,
        };
        this.$q.clearanceManagement.goodsAdjustApply({data: params}).then(({ data }) => {
          this.$message.success('调整成功')
          this.isVisible = false;
          this.$emit("finish");
        }).finally(()=>{
          this.loading = false;
        })
      });
    },
  },
  created() {
    this.init();
  },
};
</script>

<style lang="stylus" scoped>
.content {
  max-height: 60vh;
  overflow-y: auto;
}

.form-input {
  width: 200px;
}

.input-number {
  >>> .el-input__inner {
    text-align: left;
  }
}

>>> .el-form .el-form-item {
  margin-bottom: 22px;
}
</style>